import { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import { TServicesByCustomerType } from '../types/services';

import ProxyClient from './clients/ProxyClient';

export const loadServices = async (organizationType: TOrganizationTypes): Promise<TServicesByCustomerType> => {
  const { data } = await ProxyClient.get<TServicesByCustomerType>(`/services`, { params: { organizationType } });

  return data;
};
